/**
 * 封装axios请求拦截器
 * @param url
 * @param data
 * @returns {Promise}
 */
import axios from 'axios'
import Vue from 'vue'

// import { Toast } from 'vant'

const hideLoading = () => {
  let loadingRequestCount = sessionStorage.getItem('loadingRequestCount')

  if (loadingRequestCount) {
    loadingRequestCount = parseInt(loadingRequestCount)
  }

  if (!loadingRequestCount || loadingRequestCount <= 0) {
    return
  }

  loadingRequestCount--

  sessionStorage.setItem('loadingRequestCount', loadingRequestCount)

  if (loadingRequestCount === 0) {
    Vue.nextTick(() => {
      // 以服务的方式调用的 Loading 需要异步关闭
      let loadingInstance = Vue.prototype.loadingInstance

      if (loadingInstance) {
        loadingInstance.close()

        Vue.prototype.loadingInstance = null
      }
    })
  }
}

// request 拦截器
axios.defaults.withCredentials = true // 允许跨域携带cookie信息
axios.interceptors.request.use(
  (config) => {
    // showLoading()
    return config
  },
  (err) => {
    return Promise.reject(err)
  }
)

// http response 拦截器
axios.interceptors.response.use(
  (response) => {
    setTimeout(() => {
      hideLoading()
    }, 200)
    return response
  },
  (error) => {
    setTimeout(() => {
      hideLoading()
    }, 200)
    return Promise.reject(error)
  }
)
export default axios



// WEBPACK FOOTER //
// ./src/https/interceptor.js